import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {
  typeOfHivTestingAnswers, peopleTargetedAnswers, frequencyOfTestingAnswers, testKitSupplierAnswers
} from '../../constants/funding-request-answers/hiv-counseling-question-answers.const';
import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';
import {FormValidationService} from '../../../../../../../services/form-validation/form-validation.service';
import {checkForValue} from '../../../../../../organisation/capacity-spectrum/components/capacity-spectrum/store/capacity-spectrum.model';

@Component({
  selector: 'app-hiv-testing',
  templateUrl: './hiv-testing.component.html',
  styleUrls: ['./hiv-testing.component.scss']
})
export class HivTestingComponent implements OnInit {

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  @Input() hivTestingForm: FormGroup;
  @Input() formValid: boolean;
  @Input() isReadOnly: boolean;
  @Input() fromReview: boolean;

  typeOfHivTestingOptions = typeOfHivTestingAnswers;
  peopleTargetedOptions = peopleTargetedAnswers;
  frequencyOfTestingOptions = frequencyOfTestingAnswers;
  testKitSupplierOptions = testKitSupplierAnswers;
  numberMask: any;

  durationOfTypeOptions = [
    {
      label: 'Days',
      value: 'Days'
    },
    {
      label: 'Months',
      value: 'Months'
    }
  ];

  constructor(public formValidationService: FormValidationService) {
  }

  ngOnInit() {
    this.numberMask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: false,
      allowNegative: false,
      includeThousandsSeparator: false
    });
  }

  checkOther(value: string | boolean, selectedValue: string, controlParent: AbstractControl, controlChild: AbstractControl) {
    checkForValue(value, selectedValue, controlParent, controlChild);
  }
}
